<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2
          class="pl-2"
        >{{ editRoute ? $t('labels.edit_escalation_factor') : $t('labels.add_escalation_factor') }}</h2>
      </div>
    </div>
    <div class="addedit-service center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-service-card">
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full p-0">
              <label>{{ $t('labels.name')}}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="escalation_factor_name"
                maxlength="250"
                v-model="name"
                icon-no-border
                :placeholder="$t('labels.escalation_factor_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('escalation_factor_name') }}</span>
            </div>
            <div class="vx-col sm: w-full p-0 mt-4 mb-6">
              <label>{{ $t('labels.escalation_factor_barrier')}}</label>
              <v-select
                multiple
                name="escalation_barrier"
                v-model="parent_id"
                :options="parentSection"
                :reduce="parentSection => parentSection.id"
                label="name"
                :closeOnSelect="false"
                class="mt-1"
              />
            </div>
          </div>
          <div class="btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-escalation-factor"
              button="submit"
            >{{ editRoute ? $t('labels.update_escalation_factor') : $t('labels.add_escalation_factor') }}</vs-button>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      parent_id: [],
      parentSection: []
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.getEscalationfactorBarriers();
    this.setValidationMessage();
    if (this.editRoute) {
      this.getEscalationfactor();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateEscalationfactors();
        }
      });
    },
    // API Integration for add-update designation
    async createUpdateEscalationfactors() {
      let input = {
        name: this.name,
        escalation_factor_barrier_ids: this.parent_id
      };
      let url = this.editRoute
        ? "/escalation-factors/update/" + this.editRoute
        : "/escalation-factors/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-escalation-factor",
        true
      );
      if (response) {
        this.$router.push({ name: "Escalationfactors" });
      }
    },
    async getEscalationfactor() {
      let response = await this.getHTTPGetResponse(
        "/escalation-factors/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let escalation_factor = data.escalation_factor;
        this.name = escalation_factor.name;
        let filteredSection = [];
        for (
          var i = 0;
          i < escalation_factor.escalation_factor_barriers.length;
          i++
        ) {
          filteredSection.push(
            escalation_factor.escalation_factor_barriers[i].id
          );
        }
        this.parent_id = filteredSection;
      }
    },
    async getEscalationfactorBarriers() {
      let input = {
        name: this.parent_id
      };
      let response = await this.getHTTPPostResponse(
        "/escalation-factor-barriers/list",
        input
      );
      if (response) {
        let preventative_req = response.data.escalation_factor_barriers;
        let filteredSection = [];
        for (var i = 0; i < preventative_req.length; i++) {
          let obj = {
            id: preventative_req[i].id,
            name: preventative_req[i].name
          };
          filteredSection.push(obj);
        }
        this.parentSection = filteredSection;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>